import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex flex-col justify-center items-center px-4 py-16">
      <div className="text-center">
        <h1 className="text-9xl font-bold text-primary-600">404</h1>
        <h2 className="text-3xl font-medium mt-4 mb-6 text-gray-800">Página no encontrada</h2>
        <p className="text-lg text-gray-600 mb-8">
          La página que estás buscando no existe o ha sido movida.
        </p>
        <Link
          to="/dashboard"
          className="px-6 py-3 bg-primary-600 text-white rounded-md hover:bg-primary-700 transition-colors"
        >
          Regresar al Inicio
        </Link>
      </div>
    </div>
  );
};

export default NotFoundPage;
